/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.add-timer-dialog {
  .add-timer-dialog-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr auto;
    gap: variables.$padding-medium variables.$padding-medium;
    grid-template-areas:
      'textfield-name textfield-name'
      'textfield-duration textfield-duration'
      'button-add-1min button-create';
    width: 300px;
    height: 250px;

    .textfield-name {
      margin-top: variables.$margin-small;
      grid-area: textfield-name;
    }

    .textfield-duration {
      grid-area: textfield-duration;

      input {
        font-size: 48px;
        text-align: center;
      }

      div {
        height: 100%;
      }
    }

    .button-add-1min {
      grid-area: button-add-1min;
    }

    .button-create {
      grid-area: button-create;
      justify-self: end;
      width: 40px;
      height: 40px;

      .icon {
        width: 40px;
        height: 40px;
      }
    }
  }

  .add-timer-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 250px;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }
}
